module.exports = __webpack_public_path__ + "img/to_draw.8709ebf9.png";